import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';



export default function IconButtonSetting() {
return(

<SettingsSuggestIcon sx={{fontSize: '170%', color: 'greydark.C100', '&:hover': { color: 'primary.dark'}, }}/>

)
}